import useSWR from "swr";
import { useApiClient } from "@/hooks/useApiClient";
import { type AxiosError } from "axios";
import type { OwnerPlotDataResponse } from "@/features/map/types";

export const useOwnerPlot = (): {
  ownerPlotData: OwnerPlotDataResponse[] | undefined;
  isLoading: boolean;
  isError: boolean;
} => {
  const { apiClient } = useApiClient();

  const fetcher = async (url: string): Promise<OwnerPlotDataResponse[]> => {
    const response = await apiClient.get<OwnerPlotDataResponse[]>(url);
    return response.data;
  };

  const { data, error } = useSWR<OwnerPlotDataResponse[], AxiosError>(
    "/map/owner",
    fetcher,
    {
      revalidateOnFocus: false,
    }
  );

  return {
    ownerPlotData: data,
    isLoading: !error && !data,
    isError: !!error,
  };
};
